import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  PostJson,
} from "../core/Helper";

export const SearchPrefix = (props) => {
  const [setSearchB, data, setData, userInfo, item, size] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "prefixid";
  const displayFieldName = "prefix";

  setSearchB({
    title: "คำนำหน้า",
    size: size ?? "sm",
    show: true,
    fieldId: idFieldName,
    fieldName: "prefix",
    sql: {
      fields: ["prefixid", "prefix"],
      tableName: `sy_prefix a  `,
      defaultCriteria: ` a.del_flag ='n' `,
      criteriaFields: [""],
      criteriaText: "",
      orderBy: ["seq"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      console.log("prefix result", result);
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "prefix",
        text: "คำหนำหน้า",
        sort: true,
        headerStyle: GetHeaderStyle("auto", "center"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};

export class PrefixService {
  static async GetItemsByText(data, user) {
    let result = await PostJson("/api/new-prefix/get-by-text", {
      data,
      user,
    });
    return result ?? null;
  }
}
